import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Categories,
  Category,
  CategoryDescription,
  CategoryName,
  Container,
  Icon
} from './SelectCategoryModal.styled';
import { Modal } from 'components/v2/Modal/Modal';
import { usePatient } from 'hooks/usePatient/usePatient';
import { pageUrl } from 'utilities/pageUrl';

import { CATEGORIES_INFO, CATEGORY_SLUG } from '../../Messages.constants';
import { CategoryIcon } from '../CategoryIcon/CategoryIcon';

export const SelectCategoryModal = ({ open, close }: { open: boolean; close: () => void }) => {
  const navigate = useNavigate();
  const { patient } = usePatient();

  const filteredCategories = patient?.patientMembership
    ? CATEGORIES_INFO.filter(category => category.slug !== CATEGORY_SLUG.BENEFITS)
    : CATEGORIES_INFO.filter(
        category =>
          category.slug !== CATEGORY_SLUG.EMPLOYER_BENEFIT &&
          category.slug !== CATEGORY_SLUG.EMPLOYER_BENEFIT_REIMBURSEMENT
      );

  if (!open) return <></>;

  return (
    <Container>
      <Modal title="Select a message category" open={open} onCancel={close}>
        <Categories>
          {filteredCategories.map(category => (
            <Category
              key={category.slug}
              data-testid={`category-${category.slug}-item`}
              onClick={() => {
                close();
                const url = pageUrl.messages({ categoryName: category.slug });
                navigate(url);
              }}
            >
              <Icon>
                <CategoryIcon size="md" icon={category.icon} />
              </Icon>
              <CategoryName $multilineEllipses={1}>{category.title}</CategoryName>
              <CategoryDescription $multilineEllipses={3}>
                {category.description}
              </CategoryDescription>
            </Category>
          ))}
        </Categories>
      </Modal>
    </Container>
  );
};
